import React from 'react'
import { ImportExportLegend } from '../legend/ImportExportLegend'
import { Top5Legend } from '../legend/Top5Legend'

export const fromNigeriaToNigeriaLegend = {
  'Import and export(USD billion)': <ImportExportLegend />,
  'Top 5 trade partners': <Top5Legend />,
}
